import { toast } from "react-toastify";
import { t } from "../i18n";

// 문구는 모듈 로드 시점이 아니라 토스트를 띄우는 순간 t() 로 읽는다(언어 전환 반영).
const MISSION_STOPPED_TOAST_ID = "mission-stopped";
const MISSION_STOP_RETURNING_TOAST_ID = "mission-stop-returning";
const MISSION_STOP_READY_TOAST_ID = "mission-stop-ready";
const MISSION_COMPLETED_TOAST_ID = "mission-completed";
const MISSION_RETURNING_TOAST_ID = "mission-returning";

// 완료 래치: mission_complete 수신을 기억해뒀다가 최종 종료(true→false) 시점의
// completed/stopped 분류에 사용한다. 미션 끝 = 착륙(disarm)이므로 이벤트 수신
// 시점에는 상태를 끝내지 않고 기억만 한다.
// (disarm 프레임 유실 시 다음 미션이 completed로 오분류되는 것을 방지).
const COMPLETION_LATCH_TTL_MS = 300_000;
let completedAt = null;
let manualStopAt = null;

export const didMissionStop = (prevMissionStatus, nextMissionStatus) =>
  prevMissionStatus === true && nextMissionStatus === false;

export const markMissionCompleted = () => {
  completedAt = Date.now();
};

export const markMissionStopRequested = () => {
  manualStopAt = Date.now();
};

export const isMissionCompletionLatched = () =>
  completedAt !== null && Date.now() - completedAt < COMPLETION_LATCH_TTL_MS;

export const isMissionStopRequestedLatched = () =>
  manualStopAt !== null && Date.now() - manualStopAt < COMPLETION_LATCH_TTL_MS;

export const clearMissionCompletionLatch = () => {
  completedAt = null;
};

export const clearMissionStopRequestedLatch = () => {
  manualStopAt = null;
};

export const clearMissionEndLatches = () => {
  clearMissionCompletionLatch();
  clearMissionStopRequestedLatch();
};

export const showMissionStoppedToast = () => {
  toast.info(t("mission.endToast.stopped"), {
    toastId: MISSION_STOPPED_TOAST_ID,
  });
};

export const showMissionStopReturningToast = () => {
  toast.info(t("mission.endToast.stopReturning"), {
    toastId: MISSION_STOP_RETURNING_TOAST_ID,
    autoClose: 10000,
  });
};

export const dismissMissionStopReturningToast = () => {
  toast.dismiss(MISSION_STOP_RETURNING_TOAST_ID);
};

export const showMissionStopReadyToast = () => {
  toast.success(t("mission.endToast.stopReady"), {
    toastId: MISSION_STOP_READY_TOAST_ID,
  });
};

export const showMissionCompletedToast = () => {
  toast.success(t("mission.endToast.completed"), {
    toastId: MISSION_COMPLETED_TOAST_ID,
  });
};

export const showMissionReturningToast = () => {
  toast.info(t("mission.endToast.returning"), {
    toastId: MISSION_RETURNING_TOAST_ID,
    autoClose: 10000,
  });
};

// 미션 상태 전환의 토스트 분류를 한 곳에서 담당한다. WS/REST폴링/PATCH 등
// 어느 경로가 전환을 관찰하든 동일하게 분류되도록 모든 호출부가 이 함수를 쓴다.
//
// 완주 판정은 호출부가 그 순간 들고 있는 mission_progress 값을 먼저 본다. 예전에는
// WS 경로만 적는 메모(completedAt)에만 의존해서, REST 폴링이 종료 전환을 먼저 보면
// 메모가 비어 있어 완주한 미션이 "Mission ended" 로 잘못 떴다. 드론은 착륙 프레임 하나에
// mission=false 와 progress=complete 를 같이 보내고, 서버가 그 프레임을 처리하며 셀 선택을
// 먼저 비우는데, 그 셀 변화가 REST 재조회를 촉발해 WS 프레임보다 앞서 판정하는 일이 생긴다.
// 메모는 progress 를 못 받은 경로를 위한 보조로만 남긴다.
export const showMissionEndToastIfNeeded = (
  prevMissionStatus,
  nextMissionStatus,
  { progress } = {}
) => {
  if (prevMissionStatus === false && nextMissionStatus === true) {
    clearMissionEndLatches();
    return;
  }
  if (!didMissionStop(prevMissionStatus, nextMissionStatus)) {
    return;
  }
  if (isMissionStopRequestedLatched()) {
    clearMissionCompletionLatch();
    return;
  }
  toast.dismiss(MISSION_RETURNING_TOAST_ID);
  toast.dismiss(MISSION_STOP_RETURNING_TOAST_ID);
  const progressSaysComplete =
    typeof progress === "string" && progress.trim().toLowerCase() === "complete";
  if (progressSaysComplete || isMissionCompletionLatched()) {
    clearMissionCompletionLatch();
    showMissionCompletedToast();
  } else {
    showMissionStoppedToast();
  }
};
